module.exports = __webpack_public_path__ + "static/media/2.60cc16f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/mouth/2.png
// module id = 801
// module chunks = 0